<script>
  export default {
    props: ['relatorioAgrupado', 'relatorio'],
    computed: {
      saldoValor() {
        return this.relatorio.reduce((total, lancamento) => {
          return total + lancamento.valorRubrica;
          }, 0);
      },
      saldoTotalValor() {
        return this.relatorio.reduce((total, lancamento) => {
          return total + lancamento.totalValorRubrica;
        }, 0);
      },
      saldoGasto() {
        return this.relatorio.reduce((total, lancamento) => {
          return total + lancamento.valorGasto;
        }, 0);
      },
      saldoSaldoTotal() {
        return this.saldoValor + this.saldoGasto;
      }
    }
  }
</script>

<template>
  <div>
    <table class="table relatorio table-bordered">
      <thead>
        <tr>
          <th>Rubrica \ Subrubrica</th>
          <th class="text-center">Valor (R$)</th>
          <th class="text-center">Total (R$)</th>
          <th class="text-center">Gasto (R$)</th>
          <th class="text-center">Saldo (R$)</th>
        </tr>
      </thead>
      <tbody v-for="(rubricas, index) in Object.entries(relatorioAgrupado)">
        <tr style="background-color: #f5f5f6e0">
          <th>{{rubricas[0]}}</th>
          <th class="text-center"></th>
          <th class="text-center"></th>
          <th class="text-center"></th>
          <th class="text-center"></th>
        </tr>

        <tr v-for="(lancamento, index) in rubricas[1]">
          <td>{{ lancamento.nomeSubRubrica }}</td>
          <td class="text-center">{{ lancamento.valorRubrica | formatarNumero }}</td>
          <td class="text-center">{{ lancamento.totalValorRubrica | formatarNumero }}</td>
          <td class="text-center">{{ lancamento.valorGasto | formatarNumero }}</td>
          <td class="text-center">{{ (lancamento.valorRubrica + lancamento.valorGasto) | formatarNumero }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr style="background-color: #F5F5F6">
          <th class="text-right"></th>
          <th class="text-center">{{ saldoValor | formatarNumero }}</th>
          <th class="text-center">{{ saldoTotalValor | formatarNumero }}</th>
          <th class="text-center">{{ saldoGasto | formatarNumero }}</th>
          <th class="text-center">{{ saldoSaldoTotal | formatarNumero }}</th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/LancamentoModelo3/Pagamentos.vue